// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      .integration-radio-btn {
        position: relative;
        top: -5px !important;
        right: 5px;
      }
      .clientId-navigation-container-ellipsis {
        width: 16%;
      }
      .clientId-navigation-container-ellipsis.ellipsis-overlay {
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
        width: auto;
        float: none;
      }
    `, "",{"version":3,"sources":["webpack://./src/app/shared/clientid-renderer/clientid-renderer.component.ts"],"names":[],"mappings":";MACM;QACE,kBAAkB;QAClB,oBAAoB;QACpB,UAAU;MACZ;MACA;QACE,UAAU;MACZ;MACA;QACE,kBAAkB;QAClB,WAAW;QACX,QAAQ;QACR,2BAA2B;QAC3B,WAAW;QACX,WAAW;MACb","sourcesContent":["\n      .integration-radio-btn {\n        position: relative;\n        top: -5px !important;\n        right: 5px;\n      }\n      .clientId-navigation-container-ellipsis {\n        width: 16%;\n      }\n      .clientId-navigation-container-ellipsis.ellipsis-overlay {\n        position: absolute;\n        right: 20px;\n        top: 50%;\n        transform: translateY(-50%);\n        width: auto;\n        float: none;\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
